import { Component } from "solid-js";

interface IconProps {
  class?: string;
}

const Icon: Component<IconProps & { d: string }> = (props) => (
  <svg
    class={props.class}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width={2}
      d={props.d}
    />
  </svg>
);

export const IconChevronRight: Component<IconProps> = (props) => (
  <Icon class={props.class} d="M9 5l7 7-7 7" />
);

export const IconChevronLeft: Component<IconProps> = (props) => (
  <Icon class={props.class} d="M15 19l-7-7 7-7" />
);

export const IconArrowLeft: Component<IconProps> = (props) => (
  <Icon class={props.class} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
);

export const IconArrowDown: Component<IconProps> = (props) => (
  <Icon class={props.class} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
);
